import { connect } from "react-redux";
import { requestGetProjectPlanByClaimId } from "../../../../store/data/thunks";
import { State } from "../../../../store/state";

import ProjectPlan from "./ProjectPlan";

const mapStateToProps = (state: State) => ({
  projectPlan: state.data.projectPlan
});

const mapDispatchToProps = {
  requestGetProjectPlanByClaimId
};

const ProjectPlanContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectPlan);

export default ProjectPlanContainer;
